import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Voucher } from '../../../data/interfaces';
import { environment } from '../../../../environments/environment';
import { ProfileCountryService } from '../../../shared/services/profile-country.service';

@Injectable({
  providedIn: 'root'
})
export class VoucherService {

  constructor(private http: HttpClient, private profileCountryService: ProfileCountryService) { }

  private getCountryParams(): any {
    const profileCountry = this.profileCountryService.getProfileCountryForApi();
    return profileCountry ? { profileCountry } : {};
  }

  getVouchers(filter: any) {
    const params = { ...filter, ...this.getCountryParams() };
    return this.http.get<Voucher[]>(`${environment.apiUrl}/voucher/list`, { params });
  }

  createVoucher(voucher: Voucher) {
    return this.http.post<Voucher>(`${environment.apiUrl}/voucher/create`, voucher);
  }

  updateVoucher({ id, ...voucher }: Voucher) {
    return this.http.post<Voucher>(`${environment.apiUrl}/voucher/update/${id}`, voucher);
  }

  deleteVoucher(voucherId: string) {
    return this.http.delete<void>(`${environment.apiUrl}/voucher/delete/${voucherId}`);
  }

  getVoucherUsages(voucherId: string) {
    return this.http.get<{ usages: VoucherUsage[] }>(`${environment.apiUrl}/voucher/${voucherId}/usages`);
  }
}

export interface VoucherUsage {
  shipmentId: string;
  shipmentNo: string;
  amount: number;
  balanceBefore: number;
  updatedAt: string;
}
